import { getOrganizationViewUrl } from '../../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../../utils/routing/reactRoute'
import { InvoiceDocumentType } from '../../../enums/invoiceDocumentType'

export const getViewLinkedInvoiceUrl = (
  approvedInvoiceId: number | undefined,
  organizationUrl: string | undefined,
): string | undefined => {
  if (approvedInvoiceId === undefined) {
    return undefined
  }

  return getOrganizationViewUrl(
    organizationUrl,
    reactRoute.organization.invoices.getViewInvoiceRoute(approvedInvoiceId.toString(), InvoiceDocumentType.Invoice),
  )
}
